var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1662_15734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70652 8.38847C7.63929 7.35483 8.78629 6.69261 9.64783 7.26765L17.429 12.4613C18.3735 13.0917 18.056 14.5532 16.935 14.7348L15.2259 15.0118L16.4695 17.1658C16.8147 17.7637 16.6099 18.5282 16.012 18.8734L14.5753 19.7029C13.9774 20.048 13.2129 19.8432 12.8677 19.2453L11.6241 17.0913L10.5297 18.433C9.81188 19.3129 8.38744 18.8571 8.31373 17.724L7.70652 8.38847ZM9.42445 9.12237L9.9081 16.5583L11.8597 14.166L14.1028 18.0511L14.8178 17.6383L12.5747 13.7531L15.6223 13.2592L9.42445 9.12237Z",
    fill: "#E87722"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9165 2.08334C5.3852 2.08334 3.33317 4.13537 3.33317 6.66667C3.33317 8.57199 4.49598 10.2077 6.15391 10.8991C6.5787 11.0762 6.77945 11.5642 6.6023 11.9889C6.42516 12.4137 5.93721 12.6145 5.51243 12.4373C3.25544 11.4961 1.6665 9.26793 1.6665 6.66667C1.6665 3.21489 4.46472 0.416672 7.9165 0.416672C11.3683 0.416672 14.1665 3.21489 14.1665 6.66667C14.1665 6.82798 14.1604 6.98802 14.1483 7.14655C14.1134 7.60546 13.7131 7.94918 13.2542 7.91427C12.7953 7.87936 12.4515 7.47904 12.4865 7.02013C12.4953 6.90362 12.4998 6.78575 12.4998 6.66667C12.4998 4.13537 10.4478 2.08334 7.9165 2.08334Z",
    fill: "#E87722"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9165 4.58334C6.76591 4.58334 5.83317 5.51608 5.83317 6.66667C5.83317 7.24979 6.07164 7.7757 6.45851 8.1548C6.78723 8.47692 6.79258 9.00453 6.47046 9.33325C6.14834 9.66197 5.62073 9.66733 5.29201 9.34521C4.59842 8.66554 4.1665 7.71579 4.1665 6.66667C4.1665 4.5956 5.84544 2.91667 7.9165 2.91667C9.6165 2.91667 11.0503 4.04721 11.5111 5.59563C11.6424 6.03675 11.3912 6.50077 10.9501 6.63205C10.509 6.76333 10.045 6.51216 9.91368 6.07105C9.65739 5.20989 8.85903 4.58334 7.9165 4.58334Z",
    fill: "#E87722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1662_15734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneClick);
export default __webpack_public_path__ + "static/media/one-click.782c7e759027ac27c44c0a27895461be.svg";
export { ForwardRef as ReactComponent };